import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import styled from 'styled-components';
import tokenizer from 'sbd';

import customTheme from 'app/style/theme';

import Markup from 'app/api/markup';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const EvenHighlight = styled.span`
  color: ${customTheme.global.colors.black};
  background-color: ${customTheme.global.colors['accent-4']};
`;

const OddHighlight = styled.span`
  color: ${customTheme.global.colors.black};
  background-color: ${customTheme.global.colors['accent-3']};
`;

const Paragraph = styled.div`
  max-width: 100%;
  hyphens: auto;
  font-size: 18px;
  line-height: 24px;
  max-width: 600px;
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  color: ${props => customTheme.global.colors[props.color]};
`;

function onClick({ newBookmarkingSelection }, index, path, sentence) {
  newBookmarkingSelection({
    path: [...path, index],
    content: sentence,
  });
}

function HighlightedSentences({ AppState, index, path, content, color }) {
  const sentences = tokenizer.sentences(content);
  const paragraphPath = path;
  const selectionPath = AppState.bookmarkingSelectionPath.slice();
  const isParagraphSelected = _.isEqual(selectionPath, paragraphPath);
  const isSelectedInParagraph = _.isEqual(
    _.take(selectionPath, paragraphPath.length),
    paragraphPath
  );
  return (
    <Paragraph color={color}>
      {sentences.map((sentence, index) => {
        let Sentence;
        const sentencePath = [...path, index];
        const isSentenceSelected = _.isEqual(selectionPath, sentencePath);
        const isEven = index % 2 === 0;
        if (
          !isParagraphSelected &&
          !isSentenceSelected &&
          isSelectedInParagraph
        ) {
          Sentence = () => (
            <span onClick={() => onClick(AppState, index, path, sentence)}>
              {Markup.parse(sentence)}{' '}
            </span>
          );
        } else if (!isParagraphSelected && !isSentenceSelected) {
          Sentence = () => <span>{Markup.parse(sentence)} </span>;
        } else if (isParagraphSelected && !isSentenceSelected) {
          Sentence = () => (
            <React.Fragment>
              {isEven && (
                <EvenHighlight
                  onClick={() => onClick(AppState, index, path, sentence)}
                >
                  {Markup.parse(sentence)}
                </EvenHighlight>
              )}
              {!isEven && (
                <OddHighlight
                  onClick={() => onClick(AppState, index, path, sentence)}
                >
                  {Markup.parse(sentence)}
                </OddHighlight>
              )}{' '}
            </React.Fragment>
          );
        } else if (!isParagraphSelected && isSentenceSelected) {
          Sentence = () => (
            <EvenHighlight
              onClick={() => onClick(AppState, index, path, sentence)}
            >
              {Markup.parse(sentence)}{' '}
            </EvenHighlight>
          );
        }
        return (
          <ScrollIntoViewIfNeeded
            key={path.concat(index)}
            elementType="span"
            options={scrollIntoViewOptions}
            active={_.isEqual(path.concat(index), AppState.selectedSectionItem)}
          >
            <Sentence />
          </ScrollIntoViewIfNeeded>
        );
      })}
    </Paragraph>
  );
}

export default inject('AppState')(observer(HighlightedSentences));



// WEBPACK FOOTER //
// ./src/app/components/HighlightedSentences.js